import { configureStore } from '@reduxjs/toolkit';
import { RootReducer } from 'Redux/reducers/rootReducer';
import thunk from 'redux-thunk';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { save, load } from 'redux-localstorage-simple';
import { browserHistory } from './browserHistory';

export const store = configureStore({
  reducer: RootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) => [
    thunk,
    routerMiddleware(browserHistory),
    save({
      states: ['navigation', 'theme'],
      namespace: 'sesam',
    }),
  ],
  preloadedState: load({
    states: ['navigation', 'theme'],
    namespace: 'sesam',
  }),
});

export type StoreType = typeof store;
export type HistoryWithStoreType = ReturnType<typeof syncHistoryWithStore>;
